import React from 'react';
import { Route, BrowserRouter, Navigate, Routes } from 'react-router-dom';
import Login from './public/Login/Login';
import Dashboard from './private/Dashboard/Dashboard';
import Users from './private/Users/Users';
import UserDetail from './private/Users/UserDetail';
import PlatformWallet from './private/PlatformWallet/PlatformWallet';
import Limits from './private/Limits/Limits';
import Settings from './private/Settings/Settings'
import Logs from './private/Logs/Logs';
import Symbols from './private/Symbols/Symbols';
import Strategies from './private/Strategies/Strategies';
import TelegramChat from './private/Users/TelegramChat';
import Messages from './private/Messages/Messages';
import TestEmail from './private/TestEmail/TestEmail';
import TelegramNews from './private/TelegramNews/TelegramNews';
import EmailNews from './private/EmailNews/EmailNews';
import Commission from './private/Commission/Commission';
import CustodyPages from './private/CustodyPages/CustodyPages';
import GerenciarAtivos from './private/Assets/GerenciarAtivos';

function Router() {

    function PrivateRoute({ children }) {
        const isAuth = localStorage.getItem("token") !== null;
        return isAuth ? children : <Navigate to="/" />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Login />} />
                <Route path="/settings" element={
                    <PrivateRoute>
                        <Settings />
                    </PrivateRoute>
                } />
                <Route path="/dashboard" element={
                    <PrivateRoute>
                        <Dashboard />
                    </PrivateRoute>
                } />
                <Route path="/platform-wallet" element={
                    <PrivateRoute>
                        <PlatformWallet />
                    </PrivateRoute>
                } />
                <Route path="/commission" element={
                    <PrivateRoute>
                        <Commission />
                    </PrivateRoute>
                } />
                <Route path="/custody-pages" element={
                    <PrivateRoute>
                        <CustodyPages />
                    </PrivateRoute>
                } />
                <Route path="/symbols" element={
                    <PrivateRoute>
                        <Symbols />
                    </PrivateRoute>
                } />
                <Route path="/logs" element={
                    <PrivateRoute>
                        <Logs />
                    </PrivateRoute>
                } />
                <Route path="/assets" element={
                    <PrivateRoute>
                        <GerenciarAtivos />
                    </PrivateRoute>
                } />
                <Route path="/users" element={
                    <PrivateRoute>
                        <Users />
                    </PrivateRoute>
                } />
                <Route path="/users/:id" element={
                    <PrivateRoute>
                        <UserDetail />
                    </PrivateRoute>
                } />
                <Route path="/limits" element={
                    <PrivateRoute>
                        <Limits />
                    </PrivateRoute>
                } />
                <Route path="/strategies" element={
                    <PrivateRoute>
                        <Strategies />
                    </PrivateRoute>
                } />
                <Route path="/telegram-chat" element={
                    <PrivateRoute>
                        <TelegramChat />
                    </PrivateRoute>
                } />
                <Route path="/messages" element={
                    <PrivateRoute>
                        <Messages />
                    </PrivateRoute>
                } />
                <Route path="/test-email" element={
                    <PrivateRoute>
                        <TestEmail />
                    </PrivateRoute>
                } />
                <Route path="/telegram-news" element={
                    <PrivateRoute>
                        <TelegramNews />
                    </PrivateRoute>
                } />
                <Route path="/email-news" element={
                    <PrivateRoute>
                        <EmailNews />
                    </PrivateRoute>
                } />
            </Routes>
        </BrowserRouter>
    )
}

export default Router;